export default function AboutSection() {
  return (
    <section id="about" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-8">
          关于韩漫网
        </h2>
        <div className="bg-background-100 rounded-xl p-6 md:p-10 border border-background-200/70">
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
            韩漫网是一个专注于免费韩漫阅读的中文平台，致力于为广大中文读者提供丰富、高质量的韩漫免费漫画资源。平台采用创新的下拉式阅读模式，让读者无需翻页即可沉浸式享受连续流畅的漫画阅读体验。
          </p>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
            我们每日同步更新热门连载韩漫，覆盖恋爱、奇幻、悬疑、动作、校园等多种题材，满足不同读者的口味偏好。无论是追更新番还是重温经典，韩漫网都是您值得信赖的韩漫免费阅读家园。
          </p>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
            韩漫网始终秉持免费开放的运营理念，为韩漫爱好者打造一个纯净、高效、友好的在线阅读社区。海量韩漫全集资源持续扩充，期待与每一位韩漫读者共同成长。
          </p>
        </div>
      </div>
    </section>
  );
}